// Use styles: "uppercase", "capitalize", "capitalize-first". All characters lowercase by default.
import { ReactElement } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { ReactComponent as InfoIcon } from "assets/images/icons/Info.svg";

type getLabelStyleType = "capitalize" | "uppercase" | "capitalize-first";

function getCustomLabels(paymentLocation?: string) {
  const userCustomLabels = JSON.parse(localStorage.getItem("user_custom_label") || "{}");
  const userDetail = JSON.parse(localStorage.getItem("cargobase_userpermissions") || "{}");
  const { company_custom_labels, locations_custom_labels, custom_labels } = userCustomLabels;

  // if paymentLocation is passed, we need to check if there are custom labels for that location
  const customLabels =
    userDetail.user_type === "shipper"
      ? paymentLocation
        ? locations_custom_labels?.find((location: any) => location.location === paymentLocation)?.custom_labels ??
          company_custom_labels
        : company_custom_labels
      : custom_labels;

  return customLabels;
}

function renderLabel({
  name,
  style,
  withoutInfo,
  returnAsString,
  customLabels,
}: {
  name: string;
  style?: getLabelStyleType;
  withoutInfo?: boolean;
  returnAsString?: boolean;
  customLabels: Record<string, { label: any; information: any }>;
}) {
  const { label } = customLabels[name];
  const { information } = customLabels[name];
  if (returnAsString) return label;
  return (
    <div className="d-flex align-items-center">
      <p style={{ display: "inline-block" }} className={`text-${style} mb-0`}>
        {label}
      </p>
      {information !== "" && !withoutInfo && (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={name} style={{ zIndex: 999999 }}>
              <span className="font-weight-normal">{information}</span>
            </Tooltip>
          }
        >
          <InfoIcon className="ml-xs" />
        </OverlayTrigger>
      )}
    </div>
  );
}

/**
 * possible options:
 * 1. avoidCaseChange - can be passed as true so label will keep it's original case.
 */
export default function getLabel(
  name: string,
  style: getLabelStyleType,
  paymentLocation?: string,
  returnAsString?: boolean,
  withoutInfo?: boolean,
) {
  const customLabels = getCustomLabels(paymentLocation);
  if (customLabels && customLabels[name]) {
    return renderLabel({ name, style, withoutInfo, returnAsString, customLabels });
  }
  return name;
}

export function getLabelWithTranslationFallback(
  name: string,
  {
    translation,
    style,
    paymentLocation,
    returnAsString,
    withoutInfo,
  }: {
    translation: string | ReactElement;
    style?: getLabelStyleType;
    paymentLocation?: string;
    returnAsString?: boolean;
    withoutInfo?: boolean;
  },
) {
  const customLabels = getCustomLabels(paymentLocation);
  if (customLabels && customLabels[name]) {
    return renderLabel({ name, style, withoutInfo, returnAsString, customLabels });
  }
  return translation;
}
